 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML000_COVER from '@/components/xhtml/000_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML02_TITLE_PAGE from '@/components/xhtml/02_Title_Page'
 import XHTML03_COPYRIGHT_PAGE from '@/components/xhtml/03_Copyright_Page'
 import XHTML00_BODY from '@/components/xhtml/00_Body'
 import XHTML01_BODY from '@/components/xhtml/01_Body'
 import XHTML04_CONTENTS from '@/components/xhtml/04_CONTENTS'
 import XHTML05_GENERAL_EDITORS__PREFACE from '@/components/xhtml/05_General_editors__preface'
 import XHTML06_ACKNOWLEDGEMENTS from '@/components/xhtml/06_Acknowledgements'
 import XHTML07_CHRONOLOGY from '@/components/xhtml/07_Chronology'
 import XHTML08_CUE_TITLES from '@/components/xhtml/08_Cue_titles'
 import XHTML09_INTRODUCTION from '@/components/xhtml/09_Introduction'
 import XHTML10_BODY from '@/components/xhtml/10_Body'
 import XHTML11_SEA_AND_SARDINIA from '@/components/xhtml/11_SEA_AND_SARDINIA'
 import XHTML12_BODY from '@/components/xhtml/12_Body'
 import XHTML13_CONTENTS from '@/components/xhtml/13_Contents'
 import XHTML14_I__AS_FAR_AS_PALERMO from '@/components/xhtml/14_I__As_far_as_Palermo'
 import XHTML15_II__THE_SEA from '@/components/xhtml/15_II__The_Sea'
 import XHTML16_III__CAGLIARI from '@/components/xhtml/16_III__Cagliari'
 import XHTML17_IV__MANDAS from '@/components/xhtml/17_IV__Mandas'
 import XHTML18_V__TO_SORGONO from '@/components/xhtml/18_V__To_Sorgono'
 import XHTML19_VI__TO_NUORO from '@/components/xhtml/19_VI__To_Nuoro'
 import XHTML20_VII__TO_TERRANOVA_AND_THE_STEAME from '@/components/xhtml/20_VII__To_Terranova_and_the_Steame'
 import XHTML21_VIII__BACK from '@/components/xhtml/21_VIII__Back'
 import XHTML22_APPENDIX__MAPS_OF_SARDINIA__SICI from '@/components/xhtml/22_Appendix__Maps_of_Sardinia__Sici'
 import XHTML23_BODY from '@/components/xhtml/23_Body'
 import XHTML24_EXPLANATORY_NOTES from '@/components/xhtml/24_Explanatory_notes'
 import XHTML25_BODY from '@/components/xhtml/25_Body'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML26_GLOSSARY_OF_SELECTED_ITALIAN_TER from '@/components/xhtml/26_Glossary_of_selected_Italian_ter'
 import XHTML27_A_NOTE_ON_POUNDS__SHILLINGS_AND from '@/components/xhtml/27_A_note_on_pounds__shillings_and'
 import XHTML888_NOTES from '@/components/xhtml/888_Notes'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_CONTENTS",
 			"name" : "xhtml/04_CONTENTS",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_General_editors__preface",
 			"name" : "xhtml/05_General_editors__preface",
 			"component" : XHTML05_GENERAL_EDITORS__PREFACE
 		},
 		{
 			"path" : "/xhtml/06_Acknowledgements",
 			"name" : "xhtml/06_Acknowledgements",
 			"component" : XHTML06_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/xhtml/07_Chronology",
 			"name" : "xhtml/07_Chronology",
 			"component" : XHTML07_CHRONOLOGY
 		},
 		{
 			"path" : "/xhtml/08_Cue_titles",
 			"name" : "xhtml/08_Cue_titles",
 			"component" : XHTML08_CUE_TITLES
 		},
 		{
 			"path" : "/xhtml/09_Introduction",
 			"name" : "xhtml/09_Introduction",
 			"component" : XHTML09_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/10_Body",
 			"name" : "xhtml/10_Body",
 			"component" : XHTML10_BODY
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js